import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { safeJsonLd } from "@/lib/structured-data";
import { getNationalStructuredData } from "@/lib/structured-data/national";
import { Header } from "@/components/site/Header";
import { HeroNoShave } from "@/components/site/HeroNoShave";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { NoShaveFacts } from "@/components/site/NoShaveFacts";
import { Footer } from "@/components/site/Footer";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));

const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/no-shave-fue-hair-transplant")({
  head: () => ({
    meta: [
      { title: "No-Shave FUE Hair Transplant | RESTORE® Hair Transplants" },
      {
        name: "description",
        content:
          "Discover the most discreet hair restoration procedure with RESTORE® No-Shave FUE™. No shaved donor area. Natural, undetectable results.",
      },
      { property: "og:title", content: "No-Shave FUE Hair Transplant | RESTORE® Hair Transplants" },
      {
        property: "og:description",
        content:
          "Discover the most discreet hair restoration procedure with RESTORE® No-Shave FUE™. No shaved donor area. Natural, undetectable results.",
      },
      { property: "og:url", content: "https://restorehair.com/no-shave-fue-hair-transplant/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/no-shave-fue-hair-transplant/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({ "@graph": getNationalStructuredData() }),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <HeroNoShave />
        <NorwoodQuiz />
        <Suspense fallback={null}>
          <NoShaveFuture />
          <NoShaveWhy />
          <Results hideEyebrowMobile />
          <NoShaveFacts />
          <Guarantee backgroundColor="#ffffff" />
          <VirtualConsult heading={<>Schedule Your<br />Complimentary Consultation Today</>} />
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
